<template>
  <div>
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('description.deleteModalDescription')"
      :confirm="deleteItem"
      v-model="deleteItemConfirmationModal"
    />
    <v-card elevation="1">
    <v-dialog
      v-model="actionsModal"
      max-width="50%"
      :persistent="isEditMode ? true : false"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t('buttons.' + (isEditMode ? 'update' : 'add')) }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver ref="priceLimitObserver" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submitForm)">
            <v-card-text>
              <v-row>
                <FormElement
                  v-model="formData.IntegrationServiceId"
                  :vertical="true"
                  :topLabel="true"
                  :labelShown="false"
                  :rules="'required'"
                  :formType="{
                    name: 'select',
                    items: {
                      data: integrationServices,
                      value: 'Id',
                      text: 'value',
                    },
                  }"
                  :lg="6"
                  :cols="12"
                  :disabled="isEditMode"
                  :placeholder="$t('labels.service')"
                  :validationLabel="$t('labels.service')"
                />
                <FormElement
                  v-model="formData.Weight"
                  :vertical="true"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="6"
                  :cols="12"
                  :placeholder="$t('labels.weight')"
                  :validationLabel="$t('labels.weight')"
                  :formType="{
                    name: 'text',
                  }"
                  :rules="'required|numeric'"
                />
                <FormElement
                  v-model="formData.Circumference"
                  :vertical="true"
                  :topLabel="true"
                  :labelShown="false"
                  :rules="'required|numeric'"
                  :validationLabel="$t('labels.circumference')"
                  :formType="{
                    name: 'text',
                  }"
                  :lg="6"
                  :cols="12"
                  :placeholder="$t('labels.circumference')"
                />
                <FormElement
                  v-model="formData.LongestSideLength"
                  :vertical="true"
                  :topLabel="true"
                  :labelShown="false"
                  :rules="'required|numeric'"
                  :validationLabel="$t('labels.longestSideLength')"
                  :formType="{
                    name: 'text',
                  }"
                  :lg="6"
                  :cols="12"
                  :placeholder="$t('labels.longestSideLength')"
                />
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="$store.state.loadingStatus"
              >
                {{ $t('buttons.save') }}
              </v-btn>
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="closeModal"
                :disabled="$store.state.loadingStatus"
              >
                {{ $t('buttons.cancel') }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <v-card-title class="d-flex flex-row" style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t('titles.priceLimits') }}</h3>
        </v-col>
      </v-row>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="openAddModal"
            >
              mdi-plus-box-outline
            </v-icon>
          </template>
          <span>{{ $t('buttons.add') }}</span>
        </v-tooltip>
        <RefreshButton :refreshFunction="loadData"></RefreshButton>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="priceLimits"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :options="{
          itemsPerPage: itemsPerPage,
        }"
        :item-key="'Id'"
        :no-data-text="$t('messages.noData')"
      >
        <template slot="item.actions" slot-scope="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="#29B7B7"
                class="mr-1"
                style="font-size: 20px"
                v-bind="attrs"
                v-on="on"
                @click="openEditModal(item)"
                :disabled="$store.state.loadingStatus"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t('labels.tooltipEdit') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="error"
                class="mr-1"
                style="font-size: 20px"
                v-bind="attrs"
                v-on="on"
                @click="
                  deleteItemConfirmationModal = true;
                  selectedItem = item.Id;
                "
                :disabled="$store.state.loadingStatus"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t('labels.tooltipDelete') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  </div>
</template>

<script>
import PriceListLimitService from '../services/PriceListLimitService';
import PortalService from '../services/PortalService';
import FormElement from '../components/FormElement.vue';
import RefreshButton from '../components/RefreshButton.vue';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';

export default {
  name: 'PriceLimits',
  components: { FormElement, RefreshButton, ConfirmationModal },
  data() {
    return {
      actionsModal: false,
      isEditMode: false,
      priceLimits: [],
      integrationServices: [],
      formData: {
        Id: null,
        Weight: 0,
        Circumference: 0,
        LongestSideLength: 0,
        IntegrationServiceId: null,
      },
      headers: [
        {
          text: this.$t('labels.service'),
          value: 'Name',
          sortable: false,
        },
        {
          text: this.$t('labels.weight'),
          value: 'Weight',
          sortable: false,
        },
        {
          text: this.$t('labels.circumference'),
          value: 'Circumference',
          sortable: false,
        },
        {
          text: this.$t('labels.longestSideLength'),
          value: 'LongestSideLength',
          sortable: false,
        },
        {
          text: this.$t('labels.actions'),
          value: 'actions',
          sortable: false,
        },
      ],
      itemsPerPage: 10,
      deleteItemConfirmationModal: false,
      selectedItem: '',
    };
  },
  mounted() {
    this.loadData();
    this.getIntegrationServices('PriceList');
  },
  methods: {
    loadData() {
      this.$store.state.loadingStatus = true;
      PriceListLimitService.getAll({
        Page: 1,
        PageSize: 1000,
      })
        .then((response) => {
          this.priceLimits = response.data.Result || [];
        })
        .catch((error) => {
          this.$store.dispatch('showAlert', {
            type: 'error',
            message: this.$t('messages.errorLoadingData'),
          });
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getIntegrationServices(type) {
      this.$store.state.loadingStatus = true;
      PortalService.getIntegrationServices(type)
        .then((response) => {
          this.integrationServices = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    openAddModal() {
      this.isEditMode = false;
      this.formData = {
        Id: null,
        Weight: 0,
        Circumference: 0,
        LongestSideLength: 0,
        IntegrationServiceId: null,
      };
      this.actionsModal = true;
    },
    openEditModal(item) {
      this.isEditMode = true;
      this.formData = {
        Id: item.Id,
        Weight: item.Weight,
        Circumference: item.Circumference,
        LongestSideLength: item.LongestSideLength,
        IntegrationServiceId: item.IntegrationServiceId,
      };
      this.actionsModal = true;
    },
    closeModal() {
      this.actionsModal = false;
      this.isEditMode = false;
      this.$refs.priceLimitObserver.reset();
    },
    submitForm() {
      this.$store.state.loadingStatus = true;

      const service = this.isEditMode
        ? PriceListLimitService.update
        : PriceListLimitService.add;
      const data = this.isEditMode
        ? {
            Id: this.formData.Id,
            Weight: this.formData.Weight,
            Circumference: this.formData.Circumference,
            LongestSideLength: this.formData.LongestSideLength,
          }
        : {
            Weight: this.formData.Weight,
            Circumference: this.formData.Circumference,
            LongestSideLength: this.formData.LongestSideLength,
            IntegrationServiceId: this.formData.IntegrationServiceId,
          };

      service(data)
        .then((response) => {
          this.$store.dispatch('showAlert', {
            type: 'success',
            message: this.$t('messages.success'),
          });
          this.closeModal();
          this.loadData();
        })
        .catch((error) => {
          this.$store.dispatch('showAlert', {
            type: 'error',
            message: this.$t('messages.error'),
          });
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    deleteItem() {
      if (this.selectedItem) {
        this.$store.state.loadingStatus = true;
        PriceListLimitService.delete(this.selectedItem)
          .then((response) => {
            window.showSuccess(this.$t('messages.successfulDelete'));
            this.loadData();
            this.deleteItemConfirmationModal = false;
          })
          .catch((error) => {
            window.showError(error);
          })
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
  },
};
</script>
